<template>
  <div class="user-card">
    <div class="card">
      <div class="card-header">
        <h5><b>{{$t("user.userDetails")}}</b></h5>
      </div>
      <div class="card-body fz-text-details p-left-35 p-right-35">
        <div class="image">
          <div v-if="user.photo_url"
            class="img"
            :style="{
              backgroundImage: 'url(' + (user.photo_url) +')'
            }"
            alt="user-img"
          />
          <img v-else src="@/assets/default-user.jpg" class="img">
        </div>
        <div class="content">
          <div class="user-header">
            <h5 class="card-title"><b>{{user.name}} {{user.last_name}}</b></h5>
            <span class="username">{{ user.username }}</span>
          </div>
          <div class="props" v-if="user.email">
            <i class="fa fa-envelope"></i>
            <p class="card-text">{{user.email}}</p>
          </div>
          <div class="props">
            <i class="fa fa-phone"></i>
            <p class="card-text">{{user.phone}}</p>
          </div>
        </div>
      </div>
      <div class="card-footer fz-text-details p-left-35 text-right">
        <button v-if="isAdminOrOps" class="btn btn-secondary mr-2" @click="resetPassword" >
           <i class="fa fa-pencil"/>  {{$t("users.resetPassword")}} 
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { setDefaultPassword } from '@/api/index';
import {
  mapState,
} from 'vuex';
export default {
  name: 'UserDetail',
  props: {
    user: {
      type: Object,
      required: true,
    },
    title: {
      type: String,
      required: false,
      default: 'User Details',
    },
    scCanUpdate: {
      type: Boolean,
      required: true,
    },
    isAdminOrOps: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
    };
  },
  computed:{
    ...mapState({
        userData: (state) => state.user,
      }),
  },
  methods:{
    resetPassword() {
      if (this.user.user_id) {
        this.G_Alert_v2({ 
          style: this.consts.Style.DANGER, 
          message: this.$t('users.resetPasswordConfirm'),
          fnOk: () => {
            setDefaultPassword(this.user.user_id)
            .then(() => { });
          }
        });
      }
    },
  },
  
};
</script>

<style lang="scss" scoped >
.user-card{
  // width: 600px;
  // margin-bottom: 20px;
  .card{
    .card-body{
      display: flex;
      .content{
        .user-header{
          margin-bottom: 10px;
          h5{
            margin: 0;
          }
          span{
            color: #A7A7A7;
          }
        }
        .props{
          margin-bottom: 10px;
          display: flex;
          i{
            margin: 5px;
          }
        }
        .controls{
          min-width: 300px;
          display: flex;
          justify-content: space-between;
        }
        .fa{
          color: $c-light-gray;
        }
      }
      .image{
        margin-right: 40px;
        .img{
          width: 120px;
          height: 120px;
          border-radius: 50%;
          background-size: cover;
        }
      }
    }
  }
}
</style>
